var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-7 lg:p-10 flex items-center justify-center gap-x-5 text-center uppercase tracking-widest",staticStyle:{"color":"var(--color-braun)","background-color":"var(--color-rosa)"}},[_vm._v(" Ein guter Kaffee am morgen vertreibt kummer und so manche sorgen! "),_c('img',{staticClass:"w-10 h-10",attrs:{"src":require("@/assets/Grafiken/heart.svg")}})])
}]

export { render, staticRenderFns }